import PreHome from './container';

export default PreHome;
